"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const DetailTitle_vue_1 = __importDefault(require("@/pages/index/components/DetailTitle.vue"));
const old_1 = __importDefault(require("@/pages/index/data/old"));
const old_2 = __importDefault(require("@/pages/index/api/old"));
const complex_utils_1 = require("complex-utils");
exports.default = (0, vue_1.defineComponent)({
    name: 'HomeAnalysisContract',
    components: {
        DetailTitle: DetailTitle_vue_1.default
    },
    data() {
        return {
            data: {
                contractNumber: undefined
            },
            contractNumber: {
                promise: null,
                list: []
            }
        };
    },
    methods: {
        onSearch(val) {
            if (this.contractNumber.promise) {
                this.contractNumber.promise.finally(() => {
                    this.$onSearch(val);
                });
            }
            else {
                this.$onSearch(val);
            }
        },
        $onSearch: (0, complex_utils_1.debounce)(function (val) {
            return new Promise((resolve) => {
                this.contractNumber.list = [];
                if (val) {
                    this.contractNumber.promise = old_2.default.findContract.require({
                        contractNumber: val,
                        pageNo: 1,
                        pageSize: 10
                    });
                    this.contractNumber.promise.then((res) => {
                        const olist = res.data.data || [];
                        for (let i = 0; i < olist.length; i++) {
                            const oitem = olist[i];
                            this.contractNumber.list.push({
                                value: oitem.contractNo,
                                label: oitem.contractNo
                            });
                        }
                    }).finally(() => {
                        this.contractNumber.promise = null;
                        resolve({ status: 'fail' });
                    });
                }
                else {
                    this.contractNumber.promise = null;
                    resolve({ status: 'success' });
                }
            });
        }, 200),
        onFinish(values) {
            old_1.default.toContract(values.contractNumber);
        },
        onReset() {
            this.$refs.form.resetFields();
        }
    }
});
